<template>
  <div class="thumbnail" :class="gradient && 'thumbnail--gradient'" v-bind="triggerAttributes">
    <img
      class="thumbnail__image"
      :class="[
        shadow && 'thumbnail__image--shadow',
        nearByHotelsExpanded ? 'thumbnail__image--nearby-hotel' : '',
        roomThumbnail && 'thumbnail__image--room'
      ]"
      :src="`${thumbnail.url}?impolicy=Card`"
      :alt="thumbnail.tooltip"
      crossorigin="anonymous"
    />
    <div v-if="logo" class="thumbnail__logo">
      <div class="thumbnail__logo-shadow">&nbsp;</div>
      <img class="thumbnail__logo-image" :src="`${logos}/${logo}.svg`" alt="thumbnail-logo" />
    </div>
    <div class="thumbnail__icon color-white" v-if="hasIcon && imagePosition > 0">
      <i class="rhg-font-icon--gallery-small thumbnail__outer-circle text-16" />
      <span v-if="imagePosition && imagePosition != ''" class="px-3">{{ imagePosition }}</span>
    </div>
  </div>
</template>

<script>
import Image from '../../domain/Image'
import { assetsUrl } from '@/infrastructure/Configuration'

export default {
  name: 'Thumbnail',
  props: {
    id: String,
    firstSubGalleryId: String,
    thumbnail: {
      type: Image
    },
    hasIcon: {
      type: Boolean
    },
    roomThumbnail: {
      type: Boolean,
      defaultValue: false
    },
    shadow: {
      type: Boolean,
      defaultValue: false
    },
    gradient: {
      type: Boolean,
      defaultValue: false
    },
    logo: {
      type: String,
      defaultValue: null
    },
    nearByHotelsExpanded: {
      type: Boolean,
      defaultValue: false
    },
    imagePosition: {
      type: String,
      default: null
    },
    triggerAttributes: Object
  },
  data: () => ({
    logos: `${assetsUrl}/img/logos/inverse`
  })
}
</script>

<style lang="scss" scoped>
.thumbnail {
  width: 100%;
  position: relative;

  @media (max-width: 992px) {
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  &--gradient {
    @media (max-width: 992px) {
      &:after {
        background: linear-gradient(to bottom, transparent 0%, black 100%);
      }
    }
  }

  &__image {
    display: block;
    width: 100%;
    height: 180px;

    &--nearby-hotel {
      max-height: 180px;
      @media (min-width: 992px) {
        max-height: 196px;
      }
    }
    &--room {
      @media (min-width: 992px) {
        border-radius: 0.5rem;
        height: 100%;
      }
    }
  }

  &__icon {
    position: absolute;
    right: 0;
    bottom: 0;
    margin: 20px;
    z-index: 1;
    display: flex;
    align-items: center;
    background-color: rgba(83, 86, 90, 0.5);
    border-radius: 25px;
    @media (min-width: 992px) {
      right: auto;
      left: 0;
    }
  }

  &__outer-circle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border-style: solid;
    border-width: 2px;
  }

  &__logo {
    position: absolute;
    top: 0;
    left: 0;
    height: 60px;
    max-width: 100px;
  }

  &__logo-shadow {
    position: absolute;
    top: 0;
    left: 0;
    background: black;
    opacity: 0.25;
    width: calc(100% + 10px);
    height: calc(100% + 10px);
  }

  &__logo-image {
    position: relative;
    top: 5px;
    left: 5px;
    width: 100%;
    height: 100%;
  }
}

html[dir='rtl'] {
  .thumbnail {
    &__icon {
      @media (max-width: 772px) {
        left: 0 !important;
        right: initial !important;
      }
      right: 0px;
      left: initial;
    }
  }
}
</style>
